<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-100 position-relative">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain shadow-lg border-0">
                <div class="pb-0 card-header text-start border-0 bg-transparent">
                  <div class="text-center mb-4">
                    <h1 class="font-weight-bolder text-info text-gradient mb-2" style="font-size: 2.5rem;">
                      Valora
                    </h1>
                    <h3 class="font-weight-bolder text-dark mb-1">
                      Bem-vindo
                    </h3>
                    <p class="mb-0 text-muted">Entre com seu email e senha para fazer login</p>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <form role="form" class="text-start" @submit.prevent="handleLogin">
                    <label class="form-label text-dark font-weight-bold">Email</label>
                    <div class="input-group input-group-outline mb-3">
                      <input
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="form-control"
                        placeholder="seu@email.com"
                        name="email"
                        required
                      />
                    </div>
                    <label class="form-label text-dark font-weight-bold">Senha</label>
                    <div class="input-group input-group-outline mb-3">
                      <input
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="form-control"
                        placeholder="Sua senha"
                        name="password"
                        required
                      />
                    </div>
                    <div class="form-check mb-3">
                      <input
                        id="rememberMe"
                        v-model="form.rememberMe"
                        type="checkbox"
                        class="form-check-input"
                        name="rememberMe"
                      />
                      <label class="form-check-label text-dark" for="rememberMe">
                        Lembrar-me
                      </label>
                    </div>
                    <div class="text-center">
                      <button
                        type="submit"
                        class="btn btn-custom-gradient w-100 my-4 mb-2 shadow-sm"
                        :disabled="loading"
                        style="padding: 0.75rem 1.5rem; font-size: 0.875rem; font-weight: 700; letter-spacing: -0.025rem;"
                        >{{ loading ? 'Entrando...' : 'Entrar' }}
                      </button>
                    </div>
                    <div v-if="error" class="alert alert-danger mt-3 border-0 shadow-sm">
                      <i class="fas fa-exclamation-circle me-2"></i>{{ error }}
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2 border-0 bg-transparent">
                  <p class="mx-auto mb-4 text-sm text-muted">
                    Não tem uma conta?
                    <router-link
                      :to="{ name: 'Sign Up' }"
                      class="text-info text-gradient font-weight-bold ms-1"
                      >Cadastre-se</router-link
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8"
              >
                <div
                  class="bg-gradient-custom oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6"
                  style="opacity: 0.9;"
                ></div>
                <div
                  class="position-absolute top-50 start-50 translate-middle text-center text-white z-index-1 d-none d-md-block"
                  style="max-width: 400px;"
                >
                  <h2 class="display-4 font-weight-bold mb-3">Valora</h2>
                  <p class="lead">Gerencie seus produtos e categorias de forma simples e eficiente</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
const body = document.getElementsByTagName("body")[0];

export default {
  name: "SignIn",
  data() {
    return {
      form: {
        email: '',
        password: '',
        rememberMe: true
      },
      loading: false,
      error: ''
    }
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    ...mapActions(["login"]),
    
    async handleLogin() {
      this.loading = true;
      this.error = '';
      
      try {
        await this.login({
          email: this.form.email,
          password: this.form.password
        });
        
        // Get redirect path from query params or default to welcome page
        const redirectPath = this.$route.query.redirect || '/welcome';
        this.$router.push(redirectPath);
        
      } catch (error) {
        console.error('Login error:', error);
        this.error = error.message || 'Erro de conexão. Por favor, tente novamente.';
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.btn-custom-gradient {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-custom-gradient:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3);
}

.btn-custom-gradient:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(23, 193, 232, 0.3);
}

.btn-custom-gradient:disabled {
  background: #6c757d;
  color: #fff;
  opacity: 0.65;
  transform: none;
  box-shadow: none;
}

.bg-gradient-custom {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
}

.text-gradient.text-info {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
</style>
